<template>
  <div>
    <!-- what we do section -->
    <div class="what bg-li py-5" id="what" v-if="lang === 'zh'">
      <h3 class="tittle text-center font-weight-bold setrver_title">
        产品&服务
      </h3>
      <div class="container1500 container py-xl-5 py-lg-3">
        <div class="inner_sec_info_w3_info mt-3">
          <div class="row price-grid-main">
            <div class="col-lg-3 col-sm-6 price-info">
              <div class="prices p-4">
                <div class="prices-top">
                  <h3 class="text-center text-wh rounded-circle">
                    <div class="bg-clr-w3l">
                      <span class="fa fa-support"></span>
                    </div>
                  </h3>
                </div>
                <div class="prices-bottom text-center new_prices">
                  <div class="prices-h border-bottom p-4">
                    <h4>OJS技术支持</h4>
                  </div>
                  <ul class="mt-4">
                    <li>
                      <img
                        src="@/assets/images/yes_svg.svg"
                        alt=""
                      />文章处理系统
                    </li>
                    <li>
                      <img src="@/assets/images/yes_svg.svg" alt="" />域名支持
                    </li>
                    <li>
                      <img src="@/assets/images/yes_svg.svg" alt="" />DOI服务
                    </li>
                    <li>
                      <img
                        src="@/assets/images/yes_svg.svg"
                        alt=""
                      />语言编辑服务
                    </li>
                    <li>
                      <img
                        src="@/assets/images/yes_svg.svg"
                        alt=""
                      />语言校对服务
                    </li>
                    <li>
                      <img src="@/assets/images/yes_svg.svg" alt="" />检索服务
                    </li>
                    <li>
                      <img src="@/assets/images/yes_svg.svg" alt="" />期刊测评
                    </li>
                    <li>
                      <img
                        src="@/assets/images/yes_svg.svg"
                        alt=""
                      />影响因子管理
                    </li>
                  </ul>
                  <a
                    href="https://www.openjournalsystems.my/"
                    class="btn button-style mt-4"
                    >查看更多</a
                  >
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-sm-6 price-info price-mkres-2">
              <div class="prices p-4 active">
                <div class="prices-top">
                  <h3 class="text-center text-wh rounded-circle">
                    <div class="bg-clr-w3l">
                      <span class="fa fa-cog"></span>
                    </div>
                  </h3>
                </div>
                <div class="prices-bottom text-center new_prices">
                  <div class="prices-h border-bottom p-4">
                    <h4>期刊评估管理</h4>
                  </div>
                  <ul class="mt-4">
                    <li>
                      <img
                        src="@/assets/images/yes_svg.svg"
                        alt=""
                      />期刊质量测评
                    </li>
                    <li>
                      <img src="@/assets/images/yes_svg.svg" alt="" />研究前沿
                    </li>
                    <li>
                      <img
                        src="@/assets/images/yes_svg.svg"
                        alt=""
                      />编辑的评估与管理
                    </li>
                    <li>
                      <img src="@/assets/images/yes_svg.svg" alt="" />合作发展
                    </li>
                    <li>
                      <img src="@/assets/images/yes_svg.svg" alt="" />数据库检索
                    </li>
                    <li>&nbsp;</li>
                    <li>&nbsp;</li>
                    <li>&nbsp;</li>
                  </ul>
                  <a
                   @click="toPath('/Journal-Evaluation-and-Management')"
                    class="btn button-style mt-4"
                    >查看更多</a
                  >
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-sm-6 price-info price-mkres">
              <div class="prices p-4">
                <div class="prices-top">
                  <h3 class="text-center text-wh rounded-circle">
                    <div class="bg-clr-w3l">
                      <span class="fa fa-spinner"></span>
                    </div>
                  </h3>
                </div>
                <div class="prices-bottom text-center new_prices">
                  <div class="prices-h border-bottom p-4">
                    <h4>影响因子管理</h4>
                  </div>
                  <ul class="mt-4">
                    <li>
                      <img
                        src="@/assets/images/yes_svg.svg"
                        alt=""
                      />引文网络分析
                    </li>
                    <li>
                      <img
                        src="@/assets/images/yes_svg.svg"
                        alt=""
                      />避免引文陷阱
                    </li>
                    <li>
                      <img
                        src="@/assets/images/yes_svg.svg"
                        alt=""
                      />提高影响因子及分区
                    </li>
                    <li>&nbsp;</li>
                    <li>&nbsp;</li>
                    <li>&nbsp;</li>
                    <li>&nbsp;</li>
                    <li>&nbsp;</li>
                  </ul>
                  <a
                    @click="toPath('/Impact-Factor-Managment')"
                    class="btn button-style mt-4"
                    >查看更多</a
                  >
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-sm-6 price-info price-mkres">
              <div class="prices p-4 active">
                <div class="prices-top">
                  <h3 class="text-center text-wh rounded-circle">
                    <div class="bg-clr-w3l">
                      <span class="fa fa-user-circle"></span>
                    </div>
                  </h3>
                </div>
                <div class="prices-bottom text-center new_prices">
                  <div class="prices-h border-bottom p-4">
                    <h4>目标作者匹配</h4>
                  </div>
                  <ul class="mt-4">
                    <li>
                      <img
                        src="@/assets/images/yes_svg.svg"
                        alt=""
                      />大数据精准匹配
                    </li>
                    <li>
                      <img
                        src="@/assets/images/yes_svg.svg"
                        alt=""
                      />社交媒体吸引
                    </li>
                    <li>&nbsp;</li>
                    <li>&nbsp;</li>
                    <li>&nbsp;</li>
                    <li>&nbsp;</li>
                    <li>&nbsp;</li>
                    <li>&nbsp;</li>
                  </ul>
                  <a
                   @click="toPath('/Qualified-Author-Targeting')"
                    class="btn button-style mt-4"
                    >查看更多</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- what we do section -->
		<div class="what bg-li py-5" id="what" v-else-if="lang == 'en'">
			<h3 class="tittle text-center font-weight-bold setrver_title">Products & Services</h3>
			<div class="container1500 container py-xl-5 py-lg-3 ">
				<div class="inner_sec_info_w3_info mt-3">
					<div class="row price-grid-main">
						<div class="col-lg-3 col-sm-6 price-info">
							<div class="prices p-4">
								<div class="prices-top">
									<h3 class="text-center text-wh rounded-circle">
										<div class="bg-clr-w3l">
											<span class="fa fa-support"></span>
										</div>
									</h3>
								</div>
								<div class="prices-bottom text-center new_prices">
									<div class="prices-h border-bottom p-4">
										<h4>OJS Support</h4>
									</div>
									<ul class="mt-4">
                                        <li><img src="@/assets/images/yes_svg.svg" alt="">Paper Processing System</li>
										<li><img src="@/assets/images/yes_svg.svg" alt="">Domain Support</li>
										<li><img src="@/assets/images/yes_svg.svg" alt="">DOI Services</li>
										<li><img src="@/assets/images/yes_svg.svg" alt="">Copy Editing</li>
										<li><img src="@/assets/images/yes_svg.svg" alt="">Proofreading</li>
										<li><img src="@/assets/images/yes_svg.svg" alt="">Indexing Support</li>
										<li><img src="@/assets/images/yes_svg.svg" alt="">Journal Evaluation</li>
										<li><img src="@/assets/images/yes_svg.svg" alt="">Impact Factor Management</li>
                                        <li>&nbsp;</li>
										
									</ul>
									<a href="https://www.openjournalsystems.my/" class="btn button-style mt-4">Read More</a>
								</div>
							</div>
						</div>
						<div class="col-lg-3 col-sm-6  price-info price-mkres-2">
							<div class="prices p-4 active">
								<div class="prices-top">
									<h3 class="text-center text-wh rounded-circle">
										<div class="bg-clr-w3l">
											<span class="fa fa-cog"></span>
										</div>
									</h3>
								</div>
								<div class="prices-bottom text-center new_prices">
									<div class="prices-h border-bottom p-4">
										<h4>Journal Evaluation & Management</h4>
									</div>
									<ul class="mt-4 for-width">
                                        <li><img src="@/assets/images/yes_svg.svg" alt="">Journal Quality Evaluation</li>
										<li><img src="@/assets/images/yes_svg.svg" alt="">Academic Intelligence</li>
										<li><img src="@/assets/images/yes_svg.svg" alt="">Talent Evaluation and Management</li>
										<li><img src="@/assets/images/yes_svg.svg" alt="">Collaboration for Development</li>
										<li><img src="@/assets/images/yes_svg.svg" alt="">Effective Indexing Process</li>
										
<li>&nbsp;</li>

									</ul>
									<a @click="toPath('/Journal-Evaluation-and-Management')"
										class="btn button-style mt-4">Read More</a>
								</div>
							</div>
						</div>
						<div class="col-lg-3 col-sm-6  price-info price-mkres">
							<div class="prices p-4">
								<div class="prices-top">
									<h3 class="text-center text-wh rounded-circle">
										<div class="bg-clr-w3l">
											<span class="fa fa-spinner"></span>
										</div>
									</h3>
								</div>
								<div class="prices-bottom text-center new_prices">
									<div class="prices-h border-bottom p-4">
										<h4>Impact Factor Managment</h4>
									</div>
									<ul class="mt-4 for-width1">
                                        <li><img src="@/assets/images/yes_svg.svg" alt="">Citation Network Analysis</li>
										<li><img src="@/assets/images/yes_svg.svg" alt="">Avoiding Citation Traps</li>
										<li><img src="@/assets/images/yes_svg.svg" alt="">Increase JIF and JCR Ranking</li>
										<li>&nbsp;</li>
										<li>&nbsp;</li>
										<li>&nbsp;</li>
										<li>&nbsp;</li>
									</ul>
									<a @click="toPath('/Impact-Factor-Managment')" class="btn button-style mt-4">Read More</a>
								</div>
							</div>
						</div>
						<div class="col-lg-3 col-sm-6  price-info price-mkres">
							<div class="prices p-4 active">
								<div class="prices-top">
									<h3 class="text-center text-wh rounded-circle">
										<div class="bg-clr-w3l">
											<span class="fa fa-user-circle"></span>
										</div>
									</h3>
								</div>
								<div class="prices-bottom text-center new_prices">
									<div class="prices-h border-bottom p-4">
										<h4>Qualified Author Targeting</h4>
									</div>
									<ul class="mt-4 for-width2">
										<li><img src="@/assets/images/yes_svg.svg" alt="">Media Pull</li>
										<li><img src="@/assets/images/yes_svg.svg" alt="">Big Data
                                            PreciseMatching</li>
										<li>&nbsp;</li>
										<li>&nbsp;</li>
										<li>&nbsp;</li>
										<li>&nbsp;</li>
										<li>&nbsp;</li>
                                        <li>&nbsp;</li>
									</ul>
									<a @click="toPath('/Qualified-Author-Targeting')" class="btn button-style mt-4">Read
										More</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>
		<!-- //what we do section -->
  </div>
  <!-- //what we do section -->
</template>

<script>
export default {
  data() {
    return {
        lang: localStorage.getItem("lang"),
    };
  },
  mounted() {
  },
  methods: {
    toPath(url){
        this.$router.push({
            path: url,
        });
    }
   
  },
};
</script>

<style lang="scss" scoped>
 .for-width li{
            margin: 0.78rem 0 !important;

        }

        .for-width1 li{
            margin: 0.86rem 0 !important;
        }
        .for-width2 li{
            margin: 0.935rem 0 !important;
        }
        .new_prices .mt-4 li{
            align-items: flex-start;
        }
        .new_prices .mt-4 li img {
            margin: 4px 6px 0 0;
}
</style>
